module.exports = __webpack_public_path__ + "img/cert-cover.6ff1dc6.webp";